<template>
  <!-- source: https://github.com/tabler/tabler-icons -->
  <svg
    class="icon icon-tabler icon-tabler-more"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle
      cx="12"
      cy="12"
      r="1"
    />
    <circle
      cx="12"
      cy="19"
      r="1"
    />
    <circle
      cx="12"
      cy="5"
      r="1"
    />
  </svg>
</template>

<style lang="scss" scoped>
.icon-tabler {
  stroke-width: 1.25;
}
</style>
